import React from 'react'
import Head from 'next/head'

const Meta = () => {
  return (
    <Head>
      <meta charSet="utf-8" />
      <meta httpEquiv="x-ua-compatible" content="ie-edge" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"
      />
      <meta httpEquiv="content-type" content="text/html;charset=utf-8" />
      <meta name="keywords" content="" />
      <link rel="shortcut icon" type="image/png" href="/icons/favicon.png" />
    </Head>
  )
}

export default Meta
